import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { PartnerForm, Event } from '../../../../interfaces';
import { PartnerApi } from '../../../../../assets/js/lb-sdk/services';
import { finalize } from 'rxjs/operators';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-partner-verification-form',
  templateUrl: './partner-verification-form.component.html',
  styleUrls: ['./partner-verification-form.component.css']
})
export class PartnerVerificationFormComponent implements OnInit {
  @Input() partner: PartnerForm;
  @Input() hideSubmitButton: Boolean;
  @Output() verify = new EventEmitter<Event>();
  @ViewChild('partnerForm') public partnerForm: NgForm;

  constructor(private partnerApi: PartnerApi) { }

  ngOnInit() { }

  invalidate() {
    this.partner.verifiedPartnerId = false;
    this.partner.verifiedPartner = false;
  }

  submit(form) {
    if (form.valid) {
      this.partner.verifiedPartnerId = false;
      this.verify.emit({ event: 'started' });
      this.partnerApi
        .exists(this.partner.partnerId)
        .pipe(finalize(() => {
          this.verify.emit({ event: 'ended' });
        }))
        .subscribe(
          type => {
            this.partner.verifiedPartnerId = true;
            this.verify.emit({ event: 'success', data: type });
          },
          error => {
            this.verify.emit({ event: 'failed', data: error.message });
          }
        );
    }
  }
}
